import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs/Rx';
import {ProcessRequest} from '../../../models/process-request.model';
import {WebSocketEventRoutingService} from './web-socket-event-routing.service';
import {WSEventType} from '../../../models/WSEventType';

@Injectable({
  providedIn: 'root'
})
export class AztecScannedWebSocketHandlerService {

  private _aztecScannedSubject: Subject<ProcessRequest>;
  private readonly _aztecScannedObservable: Observable<ProcessRequest>;

  constructor(private webSocketEventRoutingService: WebSocketEventRoutingService) {
    let subject = new Subject<any>();
    subject.asObservable().subscribe(aztecScanned => {
      this._aztecScannedSubject.next(aztecScanned);
    });
    this.webSocketEventRoutingService.subscribe(WSEventType.AZTEC_SCANNED, subject);
    this._aztecScannedSubject = new Subject<ProcessRequest>();
    this._aztecScannedObservable = this._aztecScannedSubject.asObservable();
  }

  get aztecScannedObservable() {
    return this._aztecScannedObservable;
  }
}
